<template>
  <section class="topic-rivers mod-pt-md mod-pb-lg">
    <h2 class="visuallyhidden">Topics</h2>
    <!-- River #1: right-to-left scroll: -->
    <div class="topic-rivers__river">
      <!-- The below width *must* be the exact width of one <ul>, plus 10px: -->
      <div class="topic-rivers__scroll" :style="riverWidth > 0 ? { width: riverWidth + 'px' } : {}">
        <div class="topic-rivers__inner-rtl">
          <!-- Below <ul> must be repeated twice for infinite scroll -->
          <ul ref="riverref">
            <li v-for="topic in topics"><a :href="topic.url" class="btn-pill">{{ topic.name }}</a></li>
          </ul>
          <ul>
            <li v-for="topic in topics"><a :href="topic.url" class="btn-pill">{{ topic.name }}</a></li>
          </ul>
        </div>
      </div>
    </div>
    <!-- River #2: left-to-right scroll: -->
    <div class="topic-rivers__river">
      <!-- The below width *must* be the exact width of one <ul>, plus 10px: -->
      <div class="topic-rivers__scroll" :style="riverWidth > 0 ? { width: riverWidth + 'px' } : {}">
        <div class="topic-rivers__inner-ltr">
          <!-- Below <ul> must be repeated twice for infinite scroll -->
          <ul>
            <li v-for="topic in topics"><a :href="topic.url" class="btn-pill">{{ topic.name }}</a></li>
          </ul>
          <ul>
            <li v-for="topic in topics"><a :href="topic.url" class="btn-pill">{{ topic.name }}</a></li>
          </ul>
        </div>
      </div>
    </div>
    <p v-if="ctaVisible" class="topic-rivers__footer"><a :href="ctaLink">{{ ctaText }}</a></p>
  </section>
</template>
<script>
  export default {
    data: () => ({
      riverWidth: 0
    }),
    props: {
      topics: {
        type: Object,
        required: true
      },
      ctaLink: {
        type: String,
        required: false
      },
      ctaText: {
        type: String,
        required: false
      }
    },
    mounted() {
      let riverWidth = 0;
      for (let topic of this.$refs.riverref.children) {
        riverWidth += topic.getBoundingClientRect().width + 10
      }
      this.riverWidth = riverWidth;
    },
    computed: {
      ctaVisible () {
        return this.ctaLink && this.ctaText
      }
    }
  }
</script>
